import { Promotion } from '@/modules/utilities/calculator/types/types.ts'

export const creditLimit = {
  data: {
    credit: 760,
    clientName: 'Pepe',
    clientLasName: 'Juanete',
    initialByLevel: 30,
    rentabilityId: 4
  }
}

export const promotionsByClient: { data: { promotion: Promotion } } = {
  data: {
    promotion: {
      id: 1,
      name: 'locura azul',
      startDate: '',
      endDate: '',
      initialPercentage: '0.4',
      noCreditLimits: false,
      rentability: {
        id: '5',
        quotes: '5',
        exchange: '1.5',
        timesQuotes: '12',
        isMain: false,
        type: ['PRODUCT']
      }
    }
  }
}
